import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AccionsComponent } from './components/simulacio/accions/accions.component';
import { AltresObservacionsComponent } from './components/simulacio/altres-observacions/altres-observacions.component';
import { ApreciacioGravetatComponent } from './components/simulacio/apreciacio-gravetat/apreciacio-gravetat.component';
import { HomeComponent } from './components/home/home.component';
import { IniciSimulacioComponent } from './components/simulacio/inici-simulacio/inici-simulacio.component';
import { QuestionariObservacionsComponent } from './components/simulacio/questionari-observacions/questionari-observacions.component';
import { ResultatRiscComponent } from './components/simulacio/resultat-risc/resultat-risc.component';
import { ValoracionsFinalsComponent } from './components/simulacio/valoracions-finals/valoracions-finals.component';
import { SimulacioComponent } from './components/simulacio/simulacio.component';
import { SimulacioGuard } from './guards/simulacio.guard';

const routes: Routes = [
	{ path: '', redirectTo: 'home', pathMatch: 'full' },
	{ path: 'home', component: HomeComponent },
	{ path: 'simulacio', canActivate: [SimulacioGuard], component: SimulacioComponent,
		children: [
			{ path: '', redirectTo: 'inici-simulacio', pathMatch: 'full' },
			{ path: 'inici-simulacio', component: IniciSimulacioComponent },
			{ path: 'questionari-observacions', component: QuestionariObservacionsComponent },
			{ path: 'apreciacio-gravetat', component: ApreciacioGravetatComponent},
			{ path: 'valoracions-finals', component: ValoracionsFinalsComponent},
			{ path: 'altres-observacions', component: AltresObservacionsComponent},
			{ path: 'resultat-risc', component: ResultatRiscComponent},
			{ path: 'accions', component: AccionsComponent},
		]
	}
];



@NgModule({
	imports: [RouterModule.forRoot(routes, {useHash: true})],
	exports: [RouterModule]
})
export class AppRoutingModule { }
